import { HttpInterceptorFn } from '@angular/common/http'
import removeNullOrUndefinedOrEmpty from '../../remove-null-or-undefined-or-empty'

export const requestBodyInterceptor: HttpInterceptorFn = (req, next) => {
	if (req.method === 'GET' || req.method === 'HEAD' || !req.body || Object.keys(req.body).length === 0) {
		return next(req)
	}
	const removedNullOrUndefinedOrEmpty = removeNullOrUndefinedOrEmpty(req.body)
	const clonedReq = req.clone({
		body: removedNullOrUndefinedOrEmpty,
	})
	return next(clonedReq)
}
